import { render, staticRenderFns } from "./storeBrandActivities.vue?vue&type=template&id=1afe5ece&scoped=true&"
import script from "./storeBrandActivities.vue?vue&type=script&lang=js&"
export * from "./storeBrandActivities.vue?vue&type=script&lang=js&"
import style0 from "./storeBrandActivities.vue?vue&type=style&index=0&lang=css&"
import style1 from "./storeBrandActivities.vue?vue&type=style&index=1&id=1afe5ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe5ece",
  null
  
)

component.options.__file = "storeBrandActivities.vue"
export default component.exports